/** The PR page's tabs, as written in its `tab` query param. Changes is the default. */
export const PR_V2_TABS = {
  CHANGES: 'changes',
  DISCUSSION: 'discussion',
} as const;

export type PrV2Tab = (typeof PR_V2_TABS)[keyof typeof PR_V2_TABS];

export const PR_V2_TAB_OPTIONS = [PR_V2_TABS.CHANGES, PR_V2_TABS.DISCUSSION] as const;

export const PR_V2_TAB_QUERY_PARAM = 'tab';

export function parsePrV2Tab(value: string | null | undefined): PrV2Tab | null {
  return PR_V2_TAB_OPTIONS.find((tab) => tab === value) ?? null;
}

/**
 * A comment to open on the PR page. `filename` and `targetHeadSha` help the Changes tab find a
 * comment whose file or commit it can't resolve from the comment id alone.
 */
export type PrV2CommentTarget = {
  tab: PrV2Tab;
  commentId: string;
  filename?: string;
  targetHeadSha?: string;
};
